import React from 'react';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/utils/DateHelper';
import styles from '@cp/pages/CaseDetails/components/Addresses/geolocations.module.scss';

const TimeStampWithSeperator = React.memo(({ timestamp }: { timestamp: number }) => {
  const date = dayjs(timestamp).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME);
  const time = dayjs(timestamp).format(DateFormat.HH_mm_a);
  const day = dayjs(timestamp).format(DateFormat.DAY);
  return (
    <div className="mt-[22px] ml-[0.5px]">
      <div className={'flex flex-row gap-[6px]'}>
        {date}
        <span className={styles.timeSeperator}>|</span>
        {time}
      </div>
      <div className={styles.timestampDay}>{day}</div>
    </div>
  );
});

export default TimeStampWithSeperator;
